/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Wrapper } from './styles';
import { ReactComponent as ErrorImg } from '../../../assets/icons/error-boundary-icon.svg';
import { Button } from '../Button';


const Error = () => {

    const navigate = useNavigate()


    return (
        <Wrapper>
            <ErrorImg />
            <h1>Whoops! <br />
                Something went wrong :(</h1>

            <p>We're sorry, it looks like we hit a snag. Please try refreshing your browser or reach out <br /> to our support team at <span>support@klasha.com</span></p>

            <Button theme='primary' label='REFRESH' width='150px' onClick={() => navigate('/')} />


        </Wrapper>
    )
}

export default Error